import { PROJECT } from "./types";

import ActionHelper from "../helpers/ActionHelper";
import moment, { isMoment } from "moment";

export const createProject = (form) => () => {
  let payload = form;

  if (moment.isMoment(payload.beginDate))
    payload.beginDate = moment(payload.beginDate).format("YYYY-MM-DD");
  if (moment.isMoment(payload.endDate))
    payload.endDate = moment(payload.endDate).format("YYYY-MM-DD");

  return ActionHelper.requestServer("POST", `/project`, payload);
};

export const getProjects =
  (params = {}) =>
  (dispatch) => {
    let urlParams = "";

    Object.keys(params).map((key) => {
      if (isMoment(params[key]))
        urlParams += `${key}=${params[key].toISOString()}&`;
      else if (params[key]) urlParams += `${key}=${params[key]}&`;
    });

    return ActionHelper.requestServer(
      "GET",
      `/project?${urlParams}`,
      null,
      PROJECT.PROJECT_GET_PROJECTS_REQUEST,
      PROJECT.PROJECT_GET_PROJECTS_SUCCESS,
      PROJECT.PROJECT_GET_PROJECTS_FAIL,
      dispatch,
    );
  };

export const getProject = (projectId) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    `/project/${projectId}`,
    null,
    PROJECT.PROJECT_GET_PROJECT_REQUEST,
    PROJECT.PROJECT_GET_PROJECT_SUCCESS,
    PROJECT.PROJECT_GET_PROJECT_FAIL,
    dispatch,
  );
};

export const updateProject = (projectId, form) => () => {
  let payload = form;

  if (moment.isMoment(payload.beginDate)) {
    payload.beginDate = moment(payload.beginDate).format("YYYY-MM-DD");
  }

  if (moment.isMoment(payload.endDate)) {
    payload.endDate = moment(payload.endDate).format("YYYY-MM-DD");
  }

  return ActionHelper.requestServer("PUT", `/project/${projectId}`, form);
};

export const deleteProject = (projectId) => (dispatch) => {
  return ActionHelper.requestServer(
    "DELETE",
    `/project/${projectId}`,
    null,
    PROJECT.PROJECT_DELETE_REQUEST,
    PROJECT.PROJECT_DELETE_SUCCESS,
    PROJECT.PROJECT_DELETE_FAIL,
    dispatch,
  );
};

export const getScheduleOfProject =
  (id, beginDatetime = null, endDatetime = null) =>
  (dispatch) => {
    let params = [];

    if (moment.isMoment(beginDatetime)) {
      beginDatetime.startOf("day");

      params.push(`beginDatetime=${beginDatetime.toISOString()}`);
    }

    if (moment.isMoment(endDatetime)) {
      endDatetime.endOf("day");

      params.push(`endDatetime=${endDatetime.toISOString()}`);
    }

    return ActionHelper.requestServer(
      "GET",
      `/project/${id}/schedule?${params.join("&")}`,
      null,
      PROJECT.PROJECT_GET_SCHEDULE_REQUEST,
      PROJECT.PROJECT_GET_SCHEDULE_SUCCESS,
      PROJECT.PROJECT_GET_SCHEDULE_FAIL,
      dispatch,
    );
  };



// WEBPACK FOOTER //
// ./src/actions/projectActions.js